import styled from 'styled-components';
import {
  SharedButtonFontStyle,
  DetailsContainerSharedStyle,
} from '../../../styles/sharedUIElemStyles';
import { variables } from '../../../styles/variables';

export const DetailsContainer = styled('div')`
  display: flex;
  ${DetailsContainerSharedStyle};
  .table__marks {
    max-width: 900px;
    .ant-table-tbody > tr > td {
      min-width: 30%;
      max-width: 33%;
    }
  }
  @media (max-width: 1500px) and (min-width: 769px), (max-width: 1024px) {
    .table__marks {
      max-width: 600px;
    }
  }
`;
export const ButtonsContainer = styled('div')`
  display: flex;
  align-content: flex-start;
  button {
    ${SharedButtonFontStyle};
  }
`;

export const NavButtonsBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem 10px 1.5rem 0;
  border-right: 1px solid ${variables.colorBorder};
  justify-content: space-between;
  .move_btn {

    margin-top: 0;
    border: none;  
    width: unset;
    min-width: unset;
    position: relative;
    z-index: 3;
    span {
      font-size: 2.4rem;
    }
    &:hover {
      box-shadow: 0px 0px 15px 5px rgba(126,126,126,0.2);
      background-color: rgba(126,126,126,0.14);
    }
    &:disabled {
      opacity: 0.3;
      &:hover {
        background-color: transparent;
        box-shadow: none;
      }
    }
  }
`;